<template>
    <span>
        <DataLabel
            :item="item"
            :hide-icon="hideIcon"
            :icon-class="iconClass"
            :none="$t('publications.nil')"
            :href="href"
            v-on="$listeners">
            <ExhibitionTags v-if="withTags" class="ml-2" :related="publication" />
        </DataLabel>
    </span>
</template>

<script>
import DataLabel from '@/js/components/common/labels/DataLabel';
import ExhibitionTags from '@/js/components/common/badges/ExhibitionTags';

export default {
    name: 'PublicationLabel',

    components: {ExhibitionTags, DataLabel},

    props: {
        publication: {type: Object, default: null},
        hideIcon: {type: Boolean},
        largeIcon: {type: Boolean},
        showLink: {type: Boolean},
        showName: {type: Boolean},
        withTags: {type: Boolean},
    },

    computed: {
        item() {
            if (!this.publication) {
                return null;
            }

            const name = this.showName
                ? this.publication.name
                : (this.publication.id_cpub || this.publication.name);

            return {name, deleted_at: this.publication.deleted_at};
        },

        iconClass() {
            if (this.largeIcon) {
                return 'fa fa-fw fa-lg fa-book';
            }

            return 'fa fa-fw fa-book';

        },

        href() {
            if (!this.publication || !this.showLink) {
                return null;
            }

            if (this.$gate.deny('read', 'publication', this.publication)) {
                return null;
            }

            return this.$toRoute('publications.editorial.index', {
                publication: this.publication.id_cpub,
            }).toString();
        },
    },
};
</script>
